import { observer } from 'mobx-react-lite'
import { Box, Checkbox, Typography, Icon } from 'shared/ui'
import type { IResponseBusinessHoursDayKey } from 'entities/Users/api/types'
import { ScheduleTimePicker } from 'pages/settings/pages/inboxes/pages/id/pages/settings/messaging/businessHours/ui/ScheduleTimePicker/ScheduleTimePicker'
import styles from './styles.module.scss'

type ICustomDayRowProps = {
  dayKey: IResponseBusinessHoursDayKey
  dayLabel: string
  isClosed: boolean
  onToggleClosed: () => void
  getDayTime: (dayKey: IResponseBusinessHoursDayKey, field: 'start' | 'end') => Date
  setDayTime: (
    dayKey: IResponseBusinessHoursDayKey,
    date: Date | null,
    field: 'start' | 'end'
  ) => void
  minTime: Date
  maxTime: Date
}

export const CustomDayRow = observer(
  ({
    dayKey,
    dayLabel,
    isClosed,
    onToggleClosed,
    getDayTime,
    setDayTime,
    minTime,
    maxTime,
  }: ICustomDayRowProps) => {
    return (
      <Box
        display={'flex'}
        alignItems={'center'}
        justifyContent={'space-between'}
        className={styles.dayRow}
      >
        <Box display={'flex'} alignItems={'center'} gap={1} flex={1}>
          <Checkbox
            checked={!isClosed}
            onChange={onToggleClosed}
            ariaLabel={`${dayLabel}Checkbox`}
          />
          <Typography
            variant='body-md-regular'
            ariaLabel={`${dayLabel}Label`}
            color='var(--content-primary-primary)'
          >
            {dayLabel}
          </Typography>
        </Box>
        {isClosed ? (
          <Box
            display={'flex'}
            alignItems={'center'}
            justifyContent={'center'}
            gap={'10px'}
            width={405}
            height={40}
            padding={'8px 12px'}
            sx={{
              backgroundColor: 'var(--background-neutral-subtle)',
              borderRadius: '8px',
            }}
          >
            <Icon icon='crescentMoon' fontSize={16} />
            <Typography
              variant='body-md-regular'
              ariaLabel={`${dayLabel}Closed`}
              color='var(--content-primary-tertiary)'
            >
              Closed
            </Typography>
          </Box>
        ) : (
          <Box display={'flex'} alignItems={'center'} gap={'16px'}>
            <ScheduleTimePicker
              field='start'
              setEveryDayTime={(date, field) => setDayTime(dayKey, date, field)}
              getEveryDayTime={(field) => getDayTime(dayKey, field)}
              minTime={minTime}
              maxTime={maxTime}
            />
            <Typography
              variant='body-md-regular'
              ariaLabel={`${dayLabel}ToLabel`}
              color='var(--content-primary-tertiary)'
            >
              to
            </Typography>
            <ScheduleTimePicker
              field='end'
              setEveryDayTime={(date, field) => setDayTime(dayKey, date, field)}
              getEveryDayTime={(field) => getDayTime(dayKey, field)}
              minTime={minTime}
              maxTime={maxTime}
            />
          </Box>
        )}
      </Box>
    )
  }
)
